import { render, staticRenderFns } from "./RecoveryLinkForm.vue?vue&type=template&id=5808a742&scoped=true"
import script from "./RecoveryLinkForm.vue?vue&type=script&lang=js"
export * from "./RecoveryLinkForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5808a742",
  null
  
)

export default component.exports